<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="6" class="offset-md-3 text-center">
        <div class="custom-container4 pb-5 funktionen-liste">
          <ul>
            <li>Eigenes Dashboard</li>
            <li>User Management</li>
            <li>Kanalpunkte editieren (auch Mods)</li>
            <li>Custom Commands</li>
            <li>Auto Nachrichten</li>
            <li>Auto Shoutout</li>
            <li>Autobenachrichtigung im Chat (Sub/Bits/Follow)</li>
            <li>Loyality Points System</li>
            <li>Giveaway mit Loyality Points</li>
            <li>Giveaway mit Chatcommand</li>
            <li>Loyality Rewards</li>
            <li>Musik pausieren bei Alerts (Subs/Bits)</li>
            <li>OBS Features (einbinden von Dailygoals: Subs/Bits)</li>
            <li>Subathontimer</li>
            <li>Songrequest via Kanalpunkte</li>
            <li>Warteschlangenliste via Kanalpunkte</li>
            <li>Discord Features</li>
          </ul>
          <p class="achtung-text">Achtung! Einige Funktionen nur mit Affiliate nutzbar</p>
        </div>
        <div
          v-if="!hidePaypalButton"
        >
          <div
            class="custom-container4 text-center"
            v-if="!paymentDone"
          >
            <h2>Jetzt 30 Tage kostenlos testen!</h2>
            <h4>Nach den 30 Tagen dann 7,50€ monatlich.</h4>
            <v-checkbox
              v-model="termsAccepted"
            >
              <template slot="label"><a href="/agb">AGB</a>  &nbsp;akzeptiert</template>
            </v-checkbox>
            <div :class="{ deactivated: !termsAccepted }">
              <div
                class="ml-9 mt-4"
                id="paypal-button-container-P-7D5329298P4840457MX5WGCA"></div>
              <stripe-buy-button
                buy-button-id="buy_btn_1PTVcuRoJt23Kd2idAidNq0W"
                :publishable-key="'pk_live_51PQzXSRoJt23Kd2i8AWwvVMIkt7fyKyAuomayJBEcpYCUOx2I'
                + 'Vb3Kukzint7qeXWbAjZ1bFtJhGcdkdgTPmaKKAP00NzuiAOLS'"
              >
              </stripe-buy-button>
            </div>
          </div>
          <div class="custom-container4 text-center" v-else>
            <h2>Danke!</h2>
            <h4>Prüf mal deine Mails!</h4>
          </div>
        </div>
        <div class="custom-container4 text-center mt-4" v-if="isDevMode">
          <v-text-field
            label="Test-E-Mail-Adresse (für die Bestätigungsmail)"
            v-model="devTestEmail"
            style="max-width: 400px; margin: 0 auto;"
          ></v-text-field>
          <v-btn color="secondary" outlined @click="startDevOnboarding" :loading="devOnboardingLoading">
            🧪 Dev: Onboarding ohne Abo testen
          </v-btn>
        </div>
      </v-col>
    </v-row>

  </v-container>
</template>
<script>
import BackendService from '@/services/BackendService';

export default {
  name: 'PricingView',

  data: () => ({
    paymentDone: false,
    termsAccepted: false,
    devOnboardingLoading: false,
    devTestEmail: '',
    isDevMode: false,
  }),
  components: {
  },
  computed: {
    hidePaypalButton() {
      return this.$store.state.user_perm && this.$store.state.user_perm >= 4;
    },
  },
  methods: {
    loadPaymentButtons() {
    },
    startDevOnboarding() {
      if (!this.devTestEmail) {
        return;
      }
      this.devOnboardingLoading = true;
      BackendService.devCreateOnboardingSession({
        email: this.devTestEmail,
        domain: `${document.location.protocol}//${document.location.host}`,
      }).then((response) => {
        this.$router.push({ name: 'new_subscription', params: { id: response.data.hash } });
      }).finally(() => {
        this.devOnboardingLoading = false;
      });
    },
  },
  mounted() {
    BackendService.getDevModeStatus().then((response) => {
      this.isDevMode = response.data.enabled;
    }).catch(() => {
      this.isDevMode = false;
    });
    if (!this.hidePaypalButton) {
      paypal.Buttons({ // eslint-disable-line
        style: {
          shape: 'rect',
          color: 'white',
          layout: 'vertical',
          label: 'subscribe',
        },
        createSubscription: (data, actions) => actions.subscription.create({
          plan_id: 'P-7D5329298P4840457MX5WGCA',
        }),
        onApprove: (data) => {
          BackendService.sendPaymentConfirmation({ id: data.subscriptionID });
          this.paymentDone = true;
        },
        onClick: () => this.termsAccepted,
      }).render('#paypal-button-container-P-7D5329298P4840457MX5WGCA');
    }
  },
};
</script>
<style lang="scss" scoped>
  .deactivated {
    opacity: 0.3;
    pointer-events: none;
  }

  .funktionen-liste ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .funktionen-liste li {
    font-family: $font-heading;
    font-weight: 700;
    font-size: 1.2rem;
    color: #c5a44e;
    padding: 4px 0;
  }

  .funktionen-liste li::before {
    content: "\25CF";
    color: #c5a44e;
    margin-right: 8px;
  }

  .achtung-text {
    font-family: $font-heading;
    font-weight: 700;
    font-size: 0.85rem;
    color: #c5a44e;
    margin-top: 12px;
    text-transform: uppercase;
  }
</style>
